import Styled from "styled-components";

export const SearchContent = Styled.div`
text-align: center;
background-color: white;
width: 100%;
height: 100%;
top: 15px;
padding: 30px 15px;
margin-bottom: 40px;
position: fixed;
overflow: hidden;
z-index: 9999;
margin-top: 76px;

.close{
    cursor: pointer;
    height: 20px;
    width: 20x;
    color: black;
    float: right;
}
`;

export const H3 = Styled.h3`
color: #0b3275;
font-weight: bold;

@media(max-width: 800px) {
    font-size: 20px;
}

`;

export const Input = Styled.input`
margin-top: 30px;
width: 100%;
padding: 7px;
border-radius: 8px;
border: none;
background-color: #ECEDF0;
box-shadow: 0 0 0 0;
outline: 0;
margin-bottom: 60px;

`;
